import { cn } from '../../../utils/string/cn.utils';

const ButtonIconGhostMedium = ({ id, icon, active = false, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'flex justify-center items-center rounded-[100px] text-black-medium hover:bg-primary-primaryVarient1 hover:text-white-high disabled:text-[#ACACAC]',
        'w-[32px] h-[32px] p-[6px]',
        active && 'bg-primary-primary text-white-high',
        props.className
      )}
    >
      {icon && (
        <div className="w-20 h-20 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default ButtonIconGhostMedium;
